import React, { useEffect, useState, useMemo, useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { message } from 'antd';
import Axios from 'axios';
import { getExchangeUrl } from '@/utils/location';
import cs from './index.module.scss';
import { useStore } from '@/models';

interface Props {
  username: string | number;
  telCountryCode?: string | undefined | number;
  isSended?: boolean;
}
const CaptchaBtn: React.FC<Props> = ({ username, telCountryCode, isSended = false }) => {
  const { t } = useTranslation();
  const { account } = useStore();
  const [time, setTime] = useState(60);
  const [allowSend, setAllowSend] = useState(true);
  const timer = useRef<any>(null);
  const { geeResult, fetchSendCode, judgeToken, fetchSendCodeLogin, isLogin } = account;

  const decrement = prevTime => {
    setTime(prevTime--);
    timer.current = setInterval(() => {
      setAllowSend(false);
      if (prevTime <= 0) {
        clearInterval(timer.current);
        setAllowSend(true);
      }
      setTime(prevTime--);
    }, 1000);
  };
  useEffect(
    () => () => {
      clearInterval(timer.current);
    },
    [],
  );
  useEffect(() => {
    if (isSended) {
      decrement(60);
      setAllowSend(false);
    }
  }, [isSended]);
  const captchaClick = () => {
    const data = {
      username,
      telCountryCode,
      judgeToken: isLogin ? '' : judgeToken,
    };
    (isLogin ? fetchSendCodeLogin(data) : fetchSendCode(data)).then(res => {
      if (res) {
        decrement(60);
        setAllowSend(false);
      } else {
        clearInterval(timer.current);
        setAllowSend(true);
      }
    });
  };

  return (
    <div id="elementId" className={cs.container}>
      {allowSend ? (
        <span className={cs.text1} onClick={captchaClick}>
          {t('common.getcode')}
        </span>
      ) : (
        <span className={cs.text2}>{t('captchaBtn.regetcode', { time })}</span>
      )}
    </div>
  );
};

export default CaptchaBtn;
